/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FreelancingExperience = {
    NewFreelancer: 'NEW_FREELANCER',
    FewJobsFreelancer: 'FEW_JOBS_FREELANCER',
    EstablishedFreelancer: 'ESTABLISHED_FREELANCER'
} as const;
export type FreelancingExperience = typeof FreelancingExperience[keyof typeof FreelancingExperience];


export function instanceOfFreelancingExperience(value: any): boolean {
    for (const key in FreelancingExperience) {
        if (Object.prototype.hasOwnProperty.call(FreelancingExperience, key)) {
            // @ts-ignore
            if (FreelancingExperience[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FreelancingExperienceFromJSON(json: any): FreelancingExperience {
    return FreelancingExperienceFromJSONTyped(json, false);
}

export function FreelancingExperienceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancingExperience {
    return json as FreelancingExperience;
}

export function FreelancingExperienceToJSON(value?: FreelancingExperience | null): any {
    return value as any;
}

